/* ==========================================================================
   HOUSE 09 — PDP v2. Галерея, опции, допы, корзина, аккордеоны.
   Никаких зависимостей, никаких !important-войн: разметка и стили наши.
   ========================================================================== */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var root = document.querySelector('[data-h09-pdp]');
    if (!root) return;

    var DATA = {};
    try { DATA = JSON.parse(root.querySelector('[data-h09-data]').textContent); } catch (e) { return; }

    var CUR = DATA.currency || 'A$';
    function money(cents) {
      return CUR + (cents / 100).toLocaleString('en-AU', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    }

    /* ----------------------------- галерея ----------------------------- */
    (function () {
      var gal = root.querySelector('[data-h09-gal]');
      if (!gal) return;
      var rail = gal.querySelector('[data-h09-gal-rail]');
      var slides = [].slice.call(rail.children);
      var thumbs = [].slice.call(gal.querySelectorAll('[data-h09-gal-thumb]'));
      var dotsBox = gal.querySelector('[data-h09-gal-dots]');
      var prev = gal.querySelector('[data-h09-gal-prev]');
      var next = gal.querySelector('[data-h09-gal-next]');
      if (slides.length < 2) { if (prev) prev.remove(); if (next) next.remove(); return; }

      var i = 0, step = 0;

      var dots = slides.map(function (_, k) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'h09-gal__dot' + (k === 0 ? ' is-active' : '');
        d.setAttribute('aria-label', 'Фото ' + (k + 1));
        d.addEventListener('click', function () { go(k); });
        dotsBox.appendChild(d);
        return d;
      });

      function measure() {
        step = slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : slides[0].offsetWidth;
        if (!step) step = slides[0].offsetWidth;
        paint();
      }
      function paint() {
        rail.style.transform = 'translateX(' + (-i * step) + 'px)';
        // Видео крутится только пока открыт его слайд — иначе оно молотит
        // в фоне и жрёт батарею на телефоне.
        slides.forEach(function (sl, k) {
          var v = sl.querySelector('[data-h09-gal-video]');
          if (!v) return;
          if (k === i) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
          else { try { v.pause(); } catch (e) {} }
        });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
        if (prev) prev.disabled = i <= 0;
        if (next) next.disabled = i >= slides.length - 1;
        var t = thumbs[i];
        if (t && t.parentElement) {
          var pr = t.parentElement.getBoundingClientRect(), tr = t.getBoundingClientRect();
          if (tr.left < pr.left || tr.right > pr.right) {
            t.parentElement.scrollTo({ left: t.offsetLeft - pr.width / 2 + tr.width / 2, behavior: 'smooth' });
          }
        }
      }
      function go(n) { i = Math.max(0, Math.min(slides.length - 1, n)); paint(); }

      if (prev) prev.addEventListener('click', function () { go(i - 1); });
      if (next) next.addEventListener('click', function () { go(i + 1); });
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });

      var sx = 0, sy = 0, mv = 0, lock = null, on = false;
      rail.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        on = true; lock = null; mv = 0;
        sx = e.touches[0].clientX; sy = e.touches[0].clientY;
        rail.style.transition = 'none';
      }, { passive: true });
      rail.addEventListener('touchmove', function (e) {
        if (!on) return;
        var dx = e.touches[0].clientX - sx, dy = e.touches[0].clientY - sy;
        if (lock === null) lock = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (lock !== 'x') return;
        mv = dx;
        rail.style.transform = 'translateX(' + (-i * step + dx) + 'px)';
      }, { passive: true });
      rail.addEventListener('touchend', function () {
        if (!on) return;
        on = false;
        rail.style.transition = '';
        if (mv < -step * 0.18) go(i + 1);
        else if (mv > step * 0.18) go(i - 1);
        else paint();
      });

      var rt;
      window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(measure, 150); });
      measure();
      window.addEventListener('load', measure);
    })();

    /* ------------------------ описание: read more ---------------------- */
    (function () {
      var desc = root.querySelector('[data-h09-desc]');
      var btn = root.querySelector('[data-h09-desc-toggle]');
      if (!desc || !btn) return;
      if (desc.scrollHeight <= desc.clientHeight + 2) { btn.style.display = 'none'; return; }
      btn.addEventListener('click', function () {
        var open = desc.classList.toggle('is-clamped') === false;
        btn.textContent = open ? 'Read less' : 'Read more';
      });
    })();

    /* --------------------- опции, допы, цена, корзина ------------------- */
    var optGroups = [].slice.call(root.querySelectorAll('[data-h09-opt]'));
    var addons = [].slice.call(root.querySelectorAll('[data-h09-addon]'));
    var current = null;

    function selected() {
      return optGroups.map(function (g) {
        var sel = g.querySelector('.h09-opt__card.is-selected');
        return sel ? sel.getAttribute('data-h09-opt-value') : null;
      });
    }
    function findVariant() {
      var v = selected();
      var hit = DATA.variants.filter(function (x) {
        return (!v[0] || x.o1 === v[0]) && (!v[1] || x.o2 === v[1]) && (!v[2] || x.o3 === v[2]);
      })[0];
      return hit || DATA.variants[0];
    }
    function addonsTotal() {
      var now = 0, was = 0;
      addons.forEach(function (a) {
        if (!a.classList.contains('is-on')) return;
        now += Number(a.getAttribute('data-price')) || 0;
        was += Number(a.getAttribute('data-compare')) || 0;
      });
      return { now: now, was: was };
    }
    function paintPrices() {
      // Если на странице есть конфигуратор — цену считает ТОЛЬКО он.
      // Иначе на загрузке варианта Shopify перебивает расчёт и посетитель
      // видит одну цену в панели и другую в смете.
      if (document.querySelector('[data-h09-cfg]')) return;
      current = findVariant();
      if (!current) return;
      var extra = addonsTotal();
      var now = current.price + extra.now;
      var was = current.compare + extra.was;
      root.querySelectorAll('[data-h09-now]').forEach(function (el) { el.textContent = money(now); });
      root.querySelectorAll('[data-h09-was]').forEach(function (el) {
        el.textContent = was > now ? money(was) : '';
      });
      root.querySelectorAll('[data-h09-save]').forEach(function (el) {
        el.textContent = was > now ? 'Save ' + money(was - now) : '';
        el.style.display = was > now ? '' : 'none';
      });
    }

    optGroups.forEach(function (g) {
      g.querySelectorAll('.h09-opt__card').forEach(function (card) {
        card.addEventListener('click', function () {
          g.querySelectorAll('.h09-opt__card').forEach(function (c) { c.classList.remove('is-selected'); });
          card.classList.add('is-selected');
          paintPrices();
        });
      });
    });

    addons.forEach(function (a) {
      var priceEl = a.querySelector('[data-h09-addon-price]');
      var now = Number(a.getAttribute('data-price')) || 0;
      var was = Number(a.getAttribute('data-compare')) || 0;
      if (priceEl) {
        priceEl.innerHTML = money(now)
          + (was > now ? '<span class="h09-add__was">' + money(was) + '</span><span class="h09-add__save">Save ' + money(was - now) + '</span>' : '');
      }
      a.addEventListener('click', function (e) {
        e.preventDefault();
        a.classList.toggle('is-on');
        paintPrices();
      });
    });

    function addToCart(btn) {
      if (!current) current = findVariant();
      if (!current) return;
      var old = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      var items = [{ id: current.id, quantity: 1 }];
      addons.forEach(function (a) {
        if (!a.classList.contains('is-on')) return;
        var id = Number(a.getAttribute('data-variant-id'));
        if (id) items.push({ id: id, quantity: 1 });
      });
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () {
          btn.textContent = 'Try again';
          btn.disabled = false;
          setTimeout(function () { btn.textContent = old; }, 2000);
        });
    }
    // Если на странице конфигуратор — кнопку ведёт ОН, через draft order с
    // посчитанной ценой. Старый обработчик кладёт в корзину фиксированный
    // вариант (самый маленький размер по старой цене в USD) и успевает увести
    // на /cart раньше, чем вернётся счёт. Два обработчика на одной кнопке.
    if (!document.querySelector('[data-h09-cfg]')) {
      root.querySelectorAll('[data-h09-atc]').forEach(function (b) {
        b.addEventListener('click', function () { addToCart(b); });
      });
    }

    paintPrices();

    /* ---------------------------- аккордеоны --------------------------- */
    root.querySelectorAll('[data-h09-acc]').forEach(function (item) {
      var btn = item.querySelector('.h09-acc__q');
      var ans = item.querySelector('.h09-acc__a');
      if (!btn || !ans || item.dataset.h09Wired) return;
      item.dataset.h09Wired = '1';
      btn.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        ans.style.height = open ? ans.scrollHeight + 'px' : '0px';
      });
      window.addEventListener('resize', function () {
        if (item.classList.contains('is-open')) ans.style.height = ans.scrollHeight + 'px';
      });
    });

    /* --------------------------- таблица размеров ----------------------- */
    root.querySelectorAll('[data-h09-sizes]').forEach(function (b) {
      b.addEventListener('click', function () {
        var rows = (DATA.sizes || []).filter(Boolean).map(function (r) {
          return '<tr>' + r.split(';').map(function (c) { return '<td>' + c.trim() + '</td>'; }).join('') + '</tr>';
        }).join('');
        var m = document.createElement('div');
        m.className = 'h09 h09-modal';
        m.innerHTML =
          '<div class="h09-modal__box">'
          + '<button type="button" class="h09-modal__x" aria-label="Закрыть">&times;</button>'
          + '<h3 class="h09-modal__h">Sizes</h3>'
          + '<table><tr><th>Width × projection</th><th>Projection</th><th>Delivered</th></tr>' + rows + '</table>'
          + '<div class="h09-modal__note">Any size to the centimetre — tell us your wall width and we build to it.</div>'
          + '</div>';
        document.body.appendChild(m);
        m.querySelector('.h09-modal__x').addEventListener('click', function () { m.remove(); });
        m.addEventListener('click', function (e) { if (e.target === m) m.remove(); });
      });
    });

    /* --------------------------- обратный звонок ------------------------ */
    (function () {
      var modal = root.querySelector('[data-h09-callback]');
      if (!modal) return;
      function open() { modal.hidden = false; document.body.style.overflow = 'hidden'; }
      function close() { modal.hidden = true; document.body.style.overflow = ''; }
      root.querySelectorAll('[data-h09-callback-open]').forEach(function (b) {
        b.addEventListener('click', open);
      });
      modal.querySelectorAll('[data-h09-callback-close]').forEach(function (b) {
        b.addEventListener('click', close);
      });
      modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
      /* На странице две формы 'contact' — чат и обратный звонок. Shopify возвращает
         обе с posted_successfully, поэтому запоминаем, какую именно отправили. */
      var cbForm = modal.querySelector('form');
      if (cbForm) cbForm.addEventListener('submit', function () {
        try { sessionStorage.setItem('h09sent', 'callback'); } catch (err) {}
      });
      var sent = '';
      try { sent = sessionStorage.getItem('h09sent') || ''; } catch (err) {}
      if (location.hash.indexOf('contact_form') > -1 && modal.querySelector('.h09-cb__ok') && sent === 'callback') open();
    })();

    /* ------------------- нижняя панель: показывать по скроллу ----------- */
    (function () {
      var bar = root.querySelector('[data-h09-bar]');
      var anchor = root.querySelector('.h09-price');
      var cfg = root.querySelector('[data-h09-cfg]');
      if (!bar || !anchor) return;
      // 04.09.2026: на первом экране панель не показываем — слишком много
      // информации до того, как человек понял, о чём цена. Появляется после
      // того, как конфигуратор хоть раз оказался на экране (латч на сессию).
      function check() {
        // Панель видна только когда юзер реально дошёл до конфигуратора:
        // его верх поднялся в верхнюю треть экрана (то есть человек скроллит
        // внутри него или ниже). На первом экране панель не появляется никогда.
        var inCfg = false;
        if (cfg) {
          var c = cfg.getBoundingClientRect();
          inCfg = c.top < window.innerHeight * 0.35;
        }
        var r = anchor.getBoundingClientRect();
        bar.classList.toggle('is-on', inCfg && (r.bottom < 0 || r.top > window.innerHeight));
      }
      window.addEventListener('scroll', check, { passive: true });
      window.addEventListener('resize', check);
      check();
    })();
  });
})();

/* ==========================================================================
   HOUSE 09 — блоки страницы (карусель, FAQ, видео, отзывы, футер)
   ========================================================================== */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {

    /* ------------------------------ карусели ------------------------------ */
    document.querySelectorAll('[data-h09-car]').forEach(function (car) {
      var rail = car.querySelector('[data-h09-car-rail]');
      var items = [].slice.call(rail.children);
      var barsBox = car.querySelector('[data-h09-car-bars]');
      var prev = car.querySelector('[data-h09-car-prev]');
      var next = car.querySelector('[data-h09-car-next]');
      if (items.length < 2) { car.querySelector('.h09-car__foot').style.display = 'none'; return; }

      var i = 0, step = 0, pages = 1, bars = [];

      function metrics() {
        step = items[1].offsetLeft - items[0].offsetLeft;
        if (!step) step = items[0].offsetWidth;
        var visible = Math.max(1, Math.round(car.querySelector('.h09-car__viewport').clientWidth / step));
        pages = Math.max(1, items.length - visible + 1);
      }
      function buildBars() {
        if (!barsBox || bars.length === pages) return;
        barsBox.innerHTML = '';
        bars = [];
        for (var k = 0; k < pages; k++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'h09-car__bar' + (k === 0 ? ' is-active' : '');
          b.setAttribute('aria-label', 'Слайд ' + (k + 1));
          (function (idx) { b.addEventListener('click', function () { go(idx); }); })(k);
          barsBox.appendChild(b);
          bars.push(b);
        }
      }
      function paint() {
        rail.style.transform = 'translateX(' + (-i * step) + 'px)';
        bars.forEach(function (b, k) { b.classList.toggle('is-active', k === i); });
        if (prev) prev.disabled = i <= 0;
        if (next) next.disabled = i >= pages - 1;
      }
      function go(n) { i = Math.max(0, Math.min(pages - 1, n)); paint(); }
      function layout() {
        metrics(); buildBars();
        if (i > pages - 1) i = pages - 1;
        var foot = car.querySelector('.h09-car__foot');
        if (foot) foot.style.display = pages < 2 ? 'none' : '';
        paint();
      }

      if (prev) prev.addEventListener('click', function () { go(i - 1); });
      if (next) next.addEventListener('click', function () { go(i + 1); });

      var sx = 0, sy = 0, mv = 0, lock = null, on = false;
      rail.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        on = true; lock = null; mv = 0;
        sx = e.touches[0].clientX; sy = e.touches[0].clientY;
      }, { passive: true });
      rail.addEventListener('touchmove', function (e) {
        if (!on) return;
        var dx = e.touches[0].clientX - sx, dy = e.touches[0].clientY - sy;
        if (lock === null) lock = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (lock === 'x') mv = dx;
      }, { passive: true });
      rail.addEventListener('touchend', function () {
        if (!on) return;
        on = false;
        if (mv < -step * 0.2) go(i + 1);
        else if (mv > step * 0.2) go(i - 1);
      });

      var rt;
      window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(layout, 150); });
      layout();
      window.addEventListener('load', layout);
    });

    /* -------------------------- аккордеоны везде -------------------------- */
    document.querySelectorAll('[data-h09-acc]').forEach(function (item) {
      if (item.dataset.h09Wired) return;
      var btn = item.querySelector('.h09-acc__q');
      var ans = item.querySelector('.h09-acc__a');
      if (!btn || !ans) return;
      item.dataset.h09Wired = '1';
      btn.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        ans.style.height = open ? ans.scrollHeight + 'px' : '0px';
      });
      window.addEventListener('resize', function () {
        if (item.classList.contains('is-open')) ans.style.height = ans.scrollHeight + 'px';
      });
    });

    /* ------------------------------ FAQ вкладки ---------------------------- */
    document.querySelectorAll('[data-h09-faq]').forEach(function (faq) {
      var tabs = [].slice.call(faq.querySelectorAll('[data-h09-faq-tab]'));
      var panels = [].slice.call(faq.querySelectorAll('[data-h09-faq-panel]'));
      tabs.forEach(function (t, k) {
        t.addEventListener('click', function () {
          tabs.forEach(function (x, n) { x.classList.toggle('is-active', n === k); });
          panels.forEach(function (p, n) { p.classList.toggle('is-active', n === k); });
        });
      });
      var first = faq.querySelector('.h09-faq__panel.is-active [data-h09-acc] .h09-acc__q');
      if (first) first.click();
    });

    /* -------------------------------- видео -------------------------------- */
    document.querySelectorAll('[data-h09-video]').forEach(function (box) {
      var btn = box.querySelector('.h09-video__play');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var src = box.getAttribute('data-src');
        if (!src) return;
        var v = document.createElement('video');
        v.src = src;
        v.setAttribute('controls', '');
        v.setAttribute('playsinline', '');
        v.setAttribute('autoplay', '');
        box.innerHTML = '';
        box.appendChild(v);
        v.play().catch(function () {});
      });
    });

    /* ------------------------- отзывы: показать ещё ------------------------ */
    document.querySelectorAll('[data-h09-reviews]').forEach(function (sec) {
      var more = sec.querySelector('[data-h09-rev-more]');
      if (!more) return;
      more.addEventListener('click', function () {
        sec.querySelectorAll('[data-h09-rev-card][hidden]').forEach(function (c) { c.hidden = false; });
        more.remove();
      });
    });

    /* --------------------------- фото в отзывах ---------------------------- */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-h09-lightbox]') : null;
      if (!btn) return;
      var box = document.createElement('div');
      box.className = 'h09 h09-lightbox';
      box.innerHTML = '<img src="' + btn.getAttribute('data-h09-lightbox') + '" alt="">';
      box.addEventListener('click', function () { box.remove(); });
      document.body.appendChild(box);
    });

    /* -------------------- футер: колонки-аккордеон на мобиле --------------- */
    document.querySelectorAll('[data-h09-foot-col]').forEach(function (col) {
      var h = col.querySelector('.h09-foot__col-h');
      if (!h) return;
      h.addEventListener('click', function () {
        if (window.matchMedia('(min-width: 750px)').matches) return;
        col.classList.toggle('is-open');
      });
    });
  });
})();

/* ------------------------------------------------------------------ *
 * Конфигуратор: два ползунка на размер, опции с наценкой, цена по
 * формуле база + ставка за м². Кнопка уходит на эндпоинт, который
 * создаёт draft order с точной ценой и возвращает ссылку на оплату.
 * ------------------------------------------------------------------ */
(function () {
  var root = document.querySelector('[data-h09-cfg]');
  if (!root) return;

  var BASE = +root.dataset.base || 0,
      RATE = +root.dataset.rate || 0,
      DEP  = +root.dataset.dep  || 0,
      CUR  = root.dataset.cur || 'A$',
      URL  = root.dataset.quote || '';

  var w = root.querySelector('[data-h09-w]'),
      p = root.querySelector('[data-h09-p]'),
      err = document.querySelector('[data-h09-cfg-err]');

  function money(v) {
    return CUR + Math.round(v).toLocaleString('en-AU');
  }

  function picked(group) {
    var box = root.querySelector('[data-h09-group="' + group + '"]');
    if (!box) return [];
    return [].slice.call(box.querySelectorAll('[aria-pressed="true"]'));
  }

  // заливка дорожки ползунка слева от бегунка
  function fill(el) {
    var pc = (el.value - el.min) / (el.max - el.min) * 100;
    el.style.setProperty('--fill', pc + '%');
  }

  // Фабричное правило GR850: ширина >= вынос + 55 см.
  // Сложенные рычаги не помещаются в более узкую кассету — такой размер не производится.
  var ARM_GAP = 100, lastSrc = null;
  function clamp() {
    var W = +w.value, P = +p.value;
    if (W - P >= ARM_GAP) return;
    if (lastSrc === p) {
      w.value = Math.min(+w.max, Math.ceil((P + ARM_GAP) / 50) * 50);
      if (+w.value - P < ARM_GAP) p.value = Math.floor((+w.value - ARM_GAP) / 50) * 50;
    } else {
      p.value = Math.max(+p.min, Math.floor((W - ARM_GAP) / 50) * 50);
    }
  }

  // --- ЦЕНА -----------------------------------------------------------------
  // ВАЖНО: модель обязана совпадать с /opt/h09quote/server.py (delivered_price).
  // Правишь тут — правь и там, иначе на витрине одна цена, а в счёте другая.
  // Считано от заводского счёта GR850 (03.08.2026) и прайса доставки TNT.
  var FX_USD_CNY = 6.72, FX_AUD_USD = 0.7188, SEA_USD_KG = 2.00,
      CAC_AUD = 500, PAY_FEE = 0.024, MARGIN = 0.40,
      // 02.09.2026: пересчитано по смете фабрики без Sauleda/LED (была
      // 2440/261, тащила внутри чужую стоимость Sauleda+LED). См.
      // /opt/h09quote/server.py и mansahaus_factory_cost_reference.md.
      FACT_BASE = 1728.79, FACT_M2 = 160.94,
      WT_BASE = 0.92, WT_W = 17.62, WT_P = -0.68, BOX_EXTRA = 0.16,
      FR_BASE = 175, FR_FUEL = 0.24, FR_GST = 0.10,
      OVERLEN = [[1.50, 18], [2.00, 39], [3.00, 52], [4.00, 320], [5.00, 576], [6.00, 767]],
      // 02.09.2026: Sauleda и LED больше не плоские +390 — доплата растёт
      // с размером, синхронизировано 1-в-1 с sauleda_extra_aud()/
      // led_extra_aud() в server.py. Меняешь тут — меняй и там.
      SAULEDA_CNY_M2 = 85.0,
      LED_ARM_BASE = 8.3, LED_ARM_PER_M = 26.2,
      // 11.09.2026: ¥800 за кассетную ленту опровергнуто фабрикой —
      // лента ¥20/м + обязательная крышка ¥3/м = ¥23 за метр ширины.
      LED_CASSETTE_CNY_PER_M = 23.0,
      // подсветка продаётся не по себестоимости: минимум и шаг — как в server.py
      LED_MIN_AUD = 219.0,
      LED_STEP_MULT = 4.0,
      WATERGUARD_CNY_PER_M = 38.0,
      // Маржа на опции выше, чем на навес — синхронно с MARGIN_OPT в server.py.
      MARGIN_OPT = 0.65,
      ARM3_WIDTH_M = 6.5;

  function grossKg(W, P) { return WT_BASE + WT_W * W + WT_P * P; }

  function waterguardExtraAud(W) {
    var aud = ((WATERGUARD_CNY_PER_M * W) / FX_USD_CNY) / FX_AUD_USD;
    return aud / (1 - MARGIN_OPT - PAY_FEE);
  }

  function sauledaExtraAud(W, P) {
    var cny = SAULEDA_CNY_M2 * W * P;
    var aud = (cny / FX_USD_CNY) / FX_AUD_USD;
    return aud / (1 - MARGIN - PAY_FEE);
  }

  function ledCostAud(W, P) {
    var armsFactor = (W >= (P <= 3.0 ? 5.5 : (P <= 3.5 ? 6.15 : 6.9)) ? 3 : 2) / 2;
    var premPair = LED_ARM_BASE + LED_ARM_PER_M * P;
    var cny = armsFactor * premPair + LED_CASSETTE_CNY_PER_M * W;
    return (cny / FX_USD_CNY) / FX_AUD_USD;
  }

  function ledExtraAud(W, P) {
    var extra = Math.max(0, ledCostAud(W, P) - ledCostAud(2.5, 1.5));
    return 0;  // 16.09.2026: LED в базе бесплатно (матчим Luxi)
  }

  function dynAdd(code, W, P) {
    if (code === 'fabric-sauleda') return Math.round(sauledaExtraAud(W, P) / 5) * 5;
    if (code === 'addon-led') return Math.round(ledExtraAud(W, P) / 5) * 5;
    if (code === 'addon-waterguard') return Math.round(waterguardExtraAud(W) / 5) * 5;
    return null;
  }

  // Доставка по себестоимости, наценки нет. Ступени: 4.00 м длины ящика и 100 кг.
  function freightAud(W, P) {
    var kg = grossKg(W, P), box = W + BOX_EXTRA, over = 0, i;
    for (i = 0; i < OVERLEN.length; i++) { if (box >= OVERLEN[i][0]) over = OVERLEN[i][1]; }
    var resi = kg < 30 ? 7 : (kg < 100 ? 67 : 205);
    var tail = kg < 100 ? 48 : (kg < 300 ? 90 : 127);
    return (FR_BASE + over + resi + tail) * (1 + FR_FUEL) * (1 + FR_GST);
  }

  // Цена на витрине: товар с маржой плюс доставка внутри. Отдельной строки нет.
  function deliveredAud(W, P) {
    var exw = (FACT_BASE + FACT_M2 * W * P) / FX_USD_CNY;
    var goods = (exw + grossKg(W, P) * SEA_USD_KG) / FX_AUD_USD;
    return (goods + CAC_AUD) / (1 - MARGIN - PAY_FEE) + freightAud(W, P);
  }

  function state() {
    var W = +w.value / 100, P = +p.value / 100, area = W * P;
    var base = deliveredAud(W, P), extra = 0, opts = [];
    ['frame', 'fabric', 'canvas', 'motor', 'addon'].forEach(function (g) {
      picked(g).forEach(function (b) {
        var dyn = dynAdd(b.dataset.code, W, P);
        extra += dyn !== null ? dyn : (+b.dataset.add || 0);
        // На сервер уходит КОД опции, не подпись. Текст на витрине можно
        // править свободно, расчёт от него больше не зависит. На странице
        // из старого кэша кода нет — уедет название, сервер понимает и его.
        opts.push(b.dataset.code || b.dataset.name);
      });
    });
    return { W: W, P: P, area: area, base: base, extra: extra, opts: opts,
             total: Math.round((base + extra) / 10) * 10 };
  }

  function set(sel, txt) {
    document.querySelectorAll(sel).forEach(function (n) { n.textContent = txt; });
  }

  // Ценники Sauleda/LED меняются вместе со слайдерами, даже пока опция
  // ещё не выбрана — иначе клиент видит "+A$390" всегда, а платит другое.
  function updateOptionPrices(W, P) {
    root.querySelectorAll('.h09-cfg__ps, .h09-add__price s').forEach(function (el) {
      var n = parseInt(el.textContent.replace(/[^\d]/g, ''), 10);
      if (n) el.textContent = money(n);
    });
    var sBtn = root.querySelector('[data-h09-pick][data-code="fabric-sauleda"]');
    if (sBtn) {
      var sEl = sBtn.querySelector('.h09-cfg__pl');
      if (sEl) sEl.textContent = '+' + money(dynAdd('fabric-sauleda', W, P));
      var sPs = sBtn.querySelector('.h09-cfg__ps');
      if (sPs) sPs.textContent = money(Math.round(dynAdd('fabric-sauleda', W, P) * 1.3 / 10) * 10);
    }
    var lBtn = root.querySelector('[data-h09-pick][data-code="addon-led"]');
    if (lBtn) {
      var lEl = lBtn.querySelector('.h09-add__price b');
      if (lEl) lEl.textContent = '+' + money(dynAdd('addon-led', W, P));
      var lPs = lBtn.querySelector('.h09-add__price s');
      if (lPs) lPs.textContent = money(Math.round(dynAdd('addon-led', W, P) * 1.3 / 10) * 10);
    }

    var gBtn = root.querySelector('[data-h09-pick][data-code="addon-waterguard"]');
    if (gBtn) {
      var gEl = gBtn.querySelector('.h09-add__price b');
      if (gEl) gEl.textContent = '+' + money(dynAdd('addon-waterguard', W, P));
      var gPs = gBtn.querySelector('.h09-add__price s');
      if (gPs) gPs.textContent = money(Math.round(dynAdd('addon-waterguard', W, P) * 1.3 / 10) * 10);
    }
  }

  function calc() {
    clamp();
    fill(w); fill(p);
    var s = state();
    updateOptionPrices(s.W, s.P);
    set('[data-h09-w-out]', s.W.toFixed(2) + ' m');
    set('[data-h09-p-out]', s.P.toFixed(2) + ' m');
    set('[data-h09-sum-size]', s.W.toFixed(2) + ' × ' + s.P.toFixed(2) + ' m · ' + s.area.toFixed(1) + ' m²');
    set('[data-h09-sum-base]', money(s.base));
    set('[data-h09-sum-opt]', s.extra ? '+' + money(s.extra) : '—');
    set('[data-h09-total]', money(s.total));
    // депозит показываем только если он реально берётся; иначе строка врёт
    var dep = root.querySelector('[data-h09-dep]');
    if (dep) {
      if (DEP > 0) { dep.textContent = money(s.total * DEP / 100); dep.hidden = false; }
      else { dep.textContent = ''; dep.hidden = true; }
    }
    var wasT = Math.round(s.total * 1.3 / 10) * 10;
    set('[data-h09-now]', money(s.total));
    set('[data-h09-was]', money(wasT));
    set('[data-h09-save]', 'Save ' + money(wasT - s.total));
  }

  [w, p].forEach(function (el) {
    el.addEventListener('input', function () { lastSrc = el; calc(); });
    el.addEventListener('change', function () { lastSrc = el; calc(); });
  });

  // ViewContent — один раз, со стартовой ценой конфигуратора
  (function () {
    var fired = false;
    setTimeout(function () {
      if (fired || !window.h09track) return;
      fired = true;
      h09track('ViewContent', {
        content_name: 'Mansahaus Electric Retractable Awning',
        content_type: 'product', currency: 'AUD', value: state().total
      });
    }, 800);
  })();

  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-h09-pick]');
    if (!b) return;
    var box = b.closest('[data-h09-group]');
    if (!box.dataset.multi) {
      box.querySelectorAll('[data-h09-pick]').forEach(function (x) {
        x.setAttribute('aria-pressed', 'false');
        x.classList.remove('is-on');
      });
      b.setAttribute('aria-pressed', 'true');
      b.classList.add('is-on');
    } else {
      var on = b.getAttribute('aria-pressed') === 'true';
      b.setAttribute('aria-pressed', on ? 'false' : 'true');
      b.classList.toggle('is-on', !on);
    }
    calc();
  });

  // оформление: контакт (+WhatsApp) -> draft order -> чекаут
  var busy = false;
  var cgEl = null, cgBtn = null;

  function cgClose() {
    if (cgEl) cgEl.classList.remove('is-on');
    if (cgBtn && cgBtn.dataset.h09Label) { cgBtn.disabled = false; cgBtn.innerHTML = cgBtn.dataset.h09Label; }
    busy = false;
  }

  function cgProceed(email, phone) {
    var s = state();
    var btn = cgBtn;
    if (btn) { btn.dataset.h09Label = btn.dataset.h09Label || btn.innerHTML; btn.disabled = true; btn.textContent = 'One moment…'; }
    var goBtn = cgEl && cgEl.querySelector('.h09cg__go');
    if (goBtn) { goBtn.disabled = true; goBtn.textContent = 'One moment…'; }
    fetch(URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        width_cm: +w.value, projection_cm: +p.value,
        area_m2: +s.area.toFixed(2), options: s.opts,
        base: Math.round(s.base), extras: s.extra, total: s.total,
        email: email || '', phone: phone || ''
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.url) {
          if (email && window.h09track) h09track('Lead', { content_name: 'Checkout contact', currency: 'AUD', value: s.total });
          if (window.h09track) h09track('InitiateCheckout', { currency: 'AUD', value: (d.total || s.total), num_items: 1 });
          location.href = d.url; return;
        }
        throw new Error((d && d.error) || 'no url');
      })
      .catch(function (e) {
        if (goBtn) { goBtn.disabled = false; goBtn.textContent = 'Continue to checkout'; }
        if (btn) { btn.disabled = false; btn.innerHTML = btn.dataset.h09Label; }
        busy = false;
        var ee = cgEl && cgEl.querySelector('.h09cg__err');
        if (ee) { ee.hidden = false; ee.textContent = (e && e.message && e.message !== 'no url') ? e.message : "Couldn't open checkout. Message us and we'll send the link."; }
      });
  }

  function cgShow(btn) {
    cgBtn = btn;
    if (!cgEl) {
      cgEl = document.createElement('div');
      cgEl.className = 'h09 h09cg';
      cgEl.innerHTML =
        '<div class="h09cg__bg" data-h09cg-close></div>' +
        '<div class="h09cg__card">' +
          '<button type="button" class="h09cg__x" data-h09cg-close aria-label="Close">&times;</button>' +
          '<h3>Where do we send<br>your quote?</h3>' +
          '<div class="h09cg__sum"></div>' +
          '<input class="h09cg__mail" type="email" placeholder="Email" autocomplete="email">' +
          '<div class="h09cg__err" hidden></div>' +
          '<button type="button" class="h09-btn h09cg__go">Continue to checkout</button>' +
          '<div class="h09cg__or">or</div>' +
          '<button type="button" class="h09cg__wa"><svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413"/></svg>Chat on WhatsApp</button>' +
        '</div>';
      document.body.appendChild(cgEl);
      cgEl.addEventListener('click', function (ev) {
        if (ev.target.closest('[data-h09cg-close]')) cgClose();
      });
      cgEl.querySelector('.h09cg__go').addEventListener('click', function () {
        var m = cgEl.querySelector('.h09cg__mail').value.trim();
        var ee = cgEl.querySelector('.h09cg__err');
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(m)) {
          ee.hidden = false; ee.textContent = 'Leave your email so we can send you the quote.';
          cgEl.querySelector('.h09cg__mail').focus();
          return;
        }
        ee.hidden = true;
        cgProceed(m, '');
      });
      cgEl.querySelector('.h09cg__wa').addEventListener('click', function () {
        var s = state();
        var msg = 'Hi Mansahaus \u2014 I\'m looking at a ' + (w.value / 100).toFixed(2) + ' x ' + (p.value / 100).toFixed(2) +
          ' m awning, ' + money(s.total) + ' delivered. ';
        if (window.h09track) h09track('Contact', { content_name: 'WhatsApp from checkout gate' });
        location.href = 'https://wa.me/12173874855?text=' + encodeURIComponent(msg);
      });
    }
    var s0 = state();
    cgEl.querySelector('.h09cg__sum').innerHTML =
      (w.value / 100).toFixed(2) + ' \u00d7 ' + (p.value / 100).toFixed(2) + ' m \u00b7 <b>' + money(s0.total) + '</b> \u00b7 delivered';
    var ee = cgEl.querySelector('.h09cg__err'); ee.hidden = true;
    cgEl.classList.add('is-on');
    setTimeout(function () { cgEl.querySelector('.h09cg__mail').focus(); }, 60);
  }

  document.querySelectorAll('[data-h09-atc]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (busy || !URL) return;
      busy = true;
      var s = state();
      if (window.h09track) h09track('AddToCart', {
        content_name: 'Mansahaus Electric Retractable Awning',
        content_type: 'product', currency: 'AUD', value: s.total,
        contents: [{ id: 'awning', quantity: 1, item_price: s.total }]
      });
      if (err) { err.hidden = true; err.textContent = ''; }
      cgShow(btn);
    });
  });

  calc();
})();


/* ------------------------------ чат-виджет -------------------------------
   Мост chat.house09.co: сообщение уходит в Telegram, ответ оттуда
   возвращается сюда. Разговор помнится по conversation_id, поэтому клиент
   может уйти, вернуться по ссылке из письма и продолжить ту же переписку.
-------------------------------------------------------------------------- */
(function () {
  var API = 'https://chat.house09.co/api/chat';
  var KEY = 'h09conv';
  var box = document.querySelector('[data-h09-chat]');
  if (!box) return;

  var log = box.querySelector('[data-h09-chat-log]');
  var form = box.querySelector('[data-h09-chat-form]');
  var idFields = box.querySelector('[data-h09-chat-id]');
  var fine = box.querySelector('[data-h09-chat-fine]');
  var badge = document.querySelector('[data-h09-chat-badge]');
  var ta = form.querySelector('textarea');
  var cid = '';
  var lastId = 0;
  var timer = null;

  try {
    var q = new URLSearchParams(location.search).get('h09c');
    cid = q || localStorage.getItem(KEY) || '';
    if (q) localStorage.setItem(KEY, q);
  } catch (e) {}

  // если разговор уже есть — имя и почта не нужны
  if (cid && idFields) idFields.hidden = true;

  function bubble(text, who) {
    var d = document.createElement('div');
    d.className = 'h09-chat__msg' + (who === 'visitor' ? ' h09-chat__msg--me' : '');
    var p = document.createElement('p');
    p.textContent = text;
    d.appendChild(p);
    log.appendChild(d);
    log.scrollTop = log.scrollHeight;
    return d;
  }

  function note(text) {
    if (fine) fine.textContent = text;
  }

  function open(e) {
    if (e) e.preventDefault();
    box.hidden = false;
    if (badge) badge.hidden = true;
    document.documentElement.style.overflow = 'hidden';
    log.scrollTop = log.scrollHeight;
    var focusEl = (idFields && !idFields.hidden) ? idFields.querySelector('input') : ta;
    if (focusEl) setTimeout(function () { focusEl.focus(); }, 60);
    poll(true);
  }
  function close() {
    box.hidden = true;
    document.documentElement.style.overflow = '';
  }

  document.querySelectorAll('[data-h09-chat-open]').forEach(function (b) {
    b.addEventListener('click', open);
  });

  // WhatsApp: подставляем контекст конфигуратора в предзаполненное сообщение
  var waBtn = box.querySelector('[data-h09-chat-wa]');
  if (waBtn) {
    waBtn.addEventListener('click', function () {
      var size = document.querySelector('[data-h09-sum-size]');
      var tot = document.querySelector('[data-h09-total]');
      var msg = "Hi Mansahaus! ";
      if (size && tot && tot.textContent.trim()) {
        msg += "I'm looking at a " + size.textContent.trim() + " awning (" + tot.textContent.trim() + "). ";
      }
      msg += "My question is: ";
      waBtn.href = 'https://wa.me/12173874855?text=' + encodeURIComponent(msg);
      if (window.h09track) h09track('Contact', { content_name: 'WhatsApp chat' });
    });
  }
  box.querySelectorAll('[data-h09-chat-close]').forEach(function (b) {
    b.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !box.hidden) close();
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href$="#h09-chat"]');
    if (a) open(e);
  });
  if (location.hash === '#h09-chat' || new URLSearchParams(location.search).get('h09c')) open();

  // Enter отправляет, Shift+Enter — перенос строки
  ta.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); form.requestSubmit(); }
  });
  ta.addEventListener('input', function () {
    ta.style.height = 'auto';
    ta.style.height = Math.min(ta.scrollHeight, 120) + 'px';
  });

  function ctx() {
    var size = document.querySelector('[data-h09-sum-size]');
    var tot = document.querySelector('[data-h09-total]');
    var bits = [];
    if (size) bits.push(size.textContent.trim());
    if (tot && tot.textContent.trim()) bits.push(tot.textContent.trim());
    return bits.length ? (location.pathname + ' · ' + bits.join(' · ')) : location.pathname;
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var text = ta.value.trim();
    if (!text) return;
    var name = '', mail = '';
    if (idFields && !idFields.hidden) {
      name = (idFields.querySelector('[name="name"]').value || '').trim();
      mail = (idFields.querySelector('[name="email"]').value || '').trim();
      // 04.09.2026: почта обязательна — без неё лид не догнать.
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mail)) {
        note('Leave your email so the reply reaches you.');
        var em = idFields.querySelector('[name="email"]');
        if (em) em.focus();
        return;
      }
    }
    bubble(text, 'visitor');
    ta.value = '';
    ta.style.height = 'auto';
    note('Sending…');

    fetch(API + '/send', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ conversation_id: cid, name: name, email: mail, page: ctx(), text: text })
    }).then(function (r) { return r.json(); }).then(function (d) {
      if (d && d.conversation_id) {
        cid = d.conversation_id;
        try { localStorage.setItem(KEY, cid); } catch (err) {}
        if (idFields) idFields.hidden = true;
        if (window.h09track) h09track('Lead', { content_name: 'Site chat', currency: 'AUD' });
        note('Sent. We reply Mon–Fri 8am–7pm AEST — the answer also lands in your inbox.');
        start();
      } else {
        note('That did not go through. Email hello@mansahaus.com and we will pick it up.');
      }
    }).catch(function () {
      note('That did not go through. Email hello@mansahaus.com and we will pick it up.');
    });
  });

  function poll(quiet) {
    if (!cid) return;
    fetch(API + '/poll?conversation_id=' + encodeURIComponent(cid) + '&after=' + lastId)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        (d.messages || []).forEach(function (m) {
          lastId = Math.max(lastId, m.id);
          bubble(m.text, 'agent');
          if (box.hidden && badge) badge.hidden = false;
        });
      }).catch(function () {});
  }

  function start() {
    if (timer) clearInterval(timer);
    timer = setInterval(function () { poll(); }, box.hidden ? 20000 : 5000);
  }
  if (cid) { poll(); start(); }
})();

/* ------------------------------------------------------------------ *
 * Мобильное меню (бургер в шапке). До 03.09.2026 кнопка была без
 * обработчика и без панели - визуально была, физически не работала.
 * ------------------------------------------------------------------ */
(function () {
  var burger = document.querySelector('[data-h09-burger]');
  var drawer = document.querySelector('[data-h09-drawer]');
  if (!burger || !drawer) return;

  function openDrawer() {
    drawer.hidden = false;
    burger.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    burger.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
    setTimeout(function () { drawer.hidden = true; }, 260);
  }

  burger.addEventListener('click', function () {
    if (drawer.hidden) openDrawer(); else closeDrawer();
  });
  [].slice.call(drawer.querySelectorAll('[data-h09-drawer-close], a')).forEach(function (el) {
    el.addEventListener('click', closeDrawer);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !drawer.hidden) closeDrawer();
  });
})();
